import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Smoothly scrolls to the element matching `location.hash` after every route
 * change. Handles cross-page links like `<Link to="/#contact-form" />`.
 */
const HashScroller = () => {
  const { pathname, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace(/^#/, '');
    // Wait one frame so the target route has rendered.
    let attempts = 0;
    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Clear hash so the same link can be re-triggered
        window.setTimeout(() => navigate(pathname, { replace: true }), 800);
        return;
      }
      if (attempts++ < 20) window.setTimeout(tryScroll, 80);
    };
    tryScroll();
  }, [pathname, hash, navigate]);

  return null;
};

export default HashScroller;
